import type {
  AutomationId,
  AutomationTemplateId,
} from "@repo/app-types/entities/automation";
import type { CopilotProposalId } from "@repo/app-types/entities/copilotProposal";
import type { PlaybookId } from "@repo/app-types/entities/playbook";
import type { To } from "react-router";
import { appPaths } from "../../app/appPaths.js";
import { buildCopilotProposalLocation } from "../copilot/copilotDeepLinks.js";

export const AUTOMATION_TEMPLATE_QUERY_PARAM = "template";

/** The new-automation editor, seeded from a template's defaults. */
export function buildNewAutomationLocation(props: {
  playbookId: PlaybookId;
  templateId: AutomationTemplateId;
}) {
  const searchParams = new URLSearchParams({
    [AUTOMATION_TEMPLATE_QUERY_PARAM]: props.templateId,
  });
  return {
    pathname: appPaths.playbookAutomationNew.build({
      playbookId: props.playbookId,
    }),
    search: `?${searchParams.toString()}`,
  } satisfies To;
}

/**
 * The editor location that pre-fills a copilot proposal. A `create_automation`
 * proposal has no saved automation, so it opens the new-automation page.
 */
export function buildAutomationProposalEditLocation(props: {
  playbookId: PlaybookId;
  automationId: AutomationId | undefined;
  proposalId: CopilotProposalId;
}) {
  return buildCopilotProposalLocation(
    props.automationId
      ? appPaths.playbookAutomation.build({
          playbookId: props.playbookId,
          automationId: props.automationId,
        })
      : appPaths.playbookAutomationNew.build({ playbookId: props.playbookId }),
    props.proposalId,
  );
}
